import { render } from "./edit.vue?vue&type=template&id=129573e8&ts=true"
import script from "./edit.vue?vue&type=script&scoped=true&lang=ts"
export * from "./edit.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__